/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import Form from "react-bootstrap/Form";
import PropTypes from "prop-types";
import { resendOTP, verifyOTP, expireOTP } from "../../actions/auth";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FadeLoader } from "react-spinners";
import { LoginMain } from "../../styles/common.style";
import { setAlert } from "../../actions/alert";

const VerifyEmail = ({
  verifyOTP,
  isVerified,
  isAuthenticated,
  resendOTP,
  expireOTP,
  resendOTPSuccess,
  resendOTPRequest,
  verifyOTPSuccess,
  user,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Persist email using useRef
  const emailRef = useRef(location?.state?.email || null);

  const [otp, setOtp] = useState(Array(6).fill(""));
  const [timeLeft, setTimeLeft] = useState(300); // 5 minutes timer
  const inputRefs = useRef([]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}m ${seconds}s`;
  };

  // Handle OTP resend
  const handleResendOTP = async () => {
    if (timeLeft === 0 && !resendOTPRequest) {
      // Ensure no duplicate API calls
      const payload = { email: emailRef.current }; // Use emailRef
      resendOTP(payload);
    }
  };

  const onChange = (e) => setOtp(e.target.value);

  const onSubmit = async (e) => {
    e.preventDefault();
    const otpString = otp.join("");
    if (!emailRef.current) {
      // Use emailRef
      setAlert("Email is required.", "danger");
      return;
    }
    const payload = { otp_code: otpString, email: emailRef.current }; // Use emailRef

    try {
      verifyOTP(payload);
    } catch (error) {
      console.error("Error verifying OTP:", error);
    }
  };

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    } else if (timeLeft === 0) {
      expireOTP({ email: emailRef.current }); // Use emailRef
    }
  }, [timeLeft]);

  useEffect(() => {
    if (resendOTPSuccess) {
      setTimeLeft(300); // Reset timer only when resendOTPSuccess changes
    }
  }, [resendOTPSuccess]);

  if (verifyOTPSuccess && isAuthenticated && isVerified) {
    let assessmentUrl = "/";
    if (
      user?.user?.userAssessmentRuns &&
      user?.user?.userAssessmentRuns?.status === "cancelled"
    ) {
      assessmentUrl = "/user-assessments/re-take";
    } else {
      switch (user?.user?.userAssessmentRuns?.progress) {
        case "intake_form":
          assessmentUrl = "/welcome-to-assessment";
          break;
        case "assessment":
          assessmentUrl = "/user-assessments";
          break;
        case "completed":
          assessmentUrl = "/my-programs";
          break;
        default:
          assessmentUrl = "/welcome-to-assessment"; // if Angela want's the user to go directly to the assessment page or home page , we can change it
      }
    }
    // ✅ Move this here: Always run regardless of token success
    navigate(assessmentUrl, { replace: true });
  }

  const handleChange = (index, e) => {
    const value = e.target.value;
    if (!/^\d*$/.test(value)) return; // Allow only numbers

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to the next input if a digit is entered
    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text").trim();
    if (!/^\d+$/.test(paste)) return; // only allow digits

    const pastedOtp = paste.split("").slice(0, 6); // max 6 digits
    const newOtp = [...otp];

    pastedOtp.forEach((digit, i) => {
      newOtp[i] = digit;
      if (inputRefs.current[i]) {
        inputRefs.current[i].value = digit;
      }
    });

    setOtp(newOtp);

    // focus next empty input (optional)
    const nextEmptyIndex = pastedOtp.length < 6 ? pastedOtp.length : 5;
    if (inputRefs.current[nextEmptyIndex]) {
      inputRefs.current[nextEmptyIndex].focus();
    }
  };

  return (
    <div className="">
      <LoginMain>
        <div className="login-main-block">
          <div className="login-main-block-left">
            <div className="login-main-block-left-link">
              <Link to="/">
                {/* <img src='/images/auth-logo.svg' alt='img' /> */}
                <img src="/images/logo-auth-2.png" alt="img" />
              </Link>
            </div>
            <div className="login-main-block-left-banner">
              <img src="/images/login-banner.png" alt="login-banner" />
            </div>
          </div>
          <div className="login-main-block-right">
            <div className="login-form-block">
              <div className="login-form-block-title">
                <h2>Verify Email</h2>
              </div>
              <Form className="form-main" onSubmit={onSubmit} action="/login">
                <div className="otp-block-input">
                  {otp.map((value, index) => (
                    <input
                      key={index}
                      ref={(el) => (inputRefs.current[index] = el)}
                      type="text"
                      value={value}
                      onChange={(e) => handleChange(index, e)}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                      maxLength="1"
                      onPaste={(e) => index === 0 && handlePaste(e)}
                    />
                  ))}
                </div>

                <div className="bottom-auth-block">
                  <div className="common-btn-main">
                    <button className="btn btn-common-auth">Verify</button>
                  </div>
                  <p className="sign-text-block">
                    Didn't receive an OTP?
                    {timeLeft > 0 ? (
                      <p style={{ color: "red" }}>
                        OTP expires in {formatTime(timeLeft)}
                      </p>
                    ) : (
                      <Link to="#" onClick={handleResendOTP}>
                        {resendOTPRequest ? (
                          <i
                            className="fa fa-spinner fa-spin"
                            style={{ fontSize: "20px", color: "red" }}
                          ></i>
                        ) : (
                          " Resend OTP"
                        )}
                      </Link>
                    )}
                  </p>
                  <p className="sign-text-block">
                    <Link to="/login">Go to Sign In</Link>
                  </p>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </LoginMain>
    </div>
  );
};
VerifyEmail.propTypes = {
  isVerified: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  resendOTP: PropTypes.func.isRequired,
  verifyOTP: PropTypes.func.isRequired,
  expireOTP: PropTypes.func.isRequired,
  verifyOTPRequest: PropTypes.bool,
  verifyOTPSuccess: PropTypes.bool.isRequired,
  verifyOTPFailure: PropTypes.bool,
  resendOTPRequest: PropTypes.bool,
  resendOTPSuccess: PropTypes.bool.isRequired,
  resendOTPFailure: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isVerified: state.auth.isVerified,
  isAuthenticated: state.auth.isAuthenticated,
  verifyOTPRequest: state.auth.verifyOTPRequest || null,
  verifyOTPSuccess: state.auth.verifyOTPSuccess || null,
  verifyOTPFailure: state.auth.verifyOTPFailure || null,
  resendOTPRequest: state.auth.resendOTPRequest || null,
  resendOTPSuccess: state.auth.resendOTPSuccess || null,
  resendOTPFailure: state.auth.resendOTPFailure || null,
  user: state.auth.user || null,
});

export default connect(mapStateToProps, { verifyOTP, resendOTP, expireOTP })(
  VerifyEmail
);
